import useCount from "../hooks/useCount";

const setCount = (num) => {
  const count = useCount();

  count.value = num
}

export default setCount
